import React from "react";

const FullPageLoader = ({ text = "Loading..." }) => {
  return (
    <div className="fullpage-loader">
      <div className="loader-content">
        <div className="spinner"></div>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default FullPageLoader;